import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const MyActivity = dynamic(() => import('./MyActivity').then(mod => mod.MyActivity));
export const MyActivityConfig = {
  emptyLabel: 'myActvity',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/myActvity`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MyActivityEditable = (props: any) => {
  return (
    <EditableComponent config={MyActivityConfig} {...props}>
      <MyActivity {...props} />
    </EditableComponent>
  );
};
